import { useUnit } from 'effector-react';
import $$api from 'models/api';
import $$ep from 'models/ep';
import { $global } from 'models/store-global';

import './ViewDocumentsButton.scss';

import HText from 'components/HText/HText';
import CommunityTab from 'components/StyledTemplates/CommunityTab';
import PopUpWrapper from 'components/StyledTemplates/PopUpWrapper';
import { Button, Frame, H1 } from 'components/StyledTemplates/StyledTemplates';

import DocumentDownloadService from 'services/DocumentDownloadService';
import ModalsService from 'services/ModalsService';
import RemainingStepsService from 'services/RemainingStepsService';

import useResources from 'hooks/useResources';

import print_docs from 'assets/print-docs.png';
import print_docs_webp from 'assets/print-docs.webp';

const ViewDocumentsButton = () => {
    const { t } = useResources();

    const ep = useUnit($$ep.stores.$epQInstance);
    const documents = useUnit($global.map((state) => state?.temp?.documents_in_progress?.documents || []));

    if (!ep) {
        return null;
    }

    const download = async () => {
        const will = documents.find(({ document_type_code }) => document_type_code === 'Will');
        if (!will) {
            return;
        }
        await DocumentDownloadService.downloadZip(will.document_id);
        await RemainingStepsService.completeStep('printed');
    };

    const ship = async () => {
        const { result: isDirectInvoicing } = await $$api.participants.isDirectInvoicingFx();
        if (isDirectInvoicing) {
            ModalsService.showModal('SHIPPING_DETAILS_COLLECT');
        } else {
            const { redirect } = await $$api.stripe.shippingPaymentFx(ep.questionnaire_instance_id);
            window.location.href = redirect;
        }
    };

    const shipmentOptionsFeatureFlag = t('features.shipmentOptions') === true;

    return (
        <PopUpWrapper name="VIEW_DOCUMENTS_MODAL" size="xl" whiteCross>
            <CommunityTab
                title={<H1 extra="font-size: 25px !important; margin: 0 !important;">{t('EPCard.printViewHeader')}</H1>}
            >
                <Frame extra="width: 100%; display: block;">
                    <div className="print-documents">
                        <div className="header">
                            {shipmentOptionsFeatureFlag
                                ? t('EPCard.printDocuments.header.withShipment')
                                : t('EPCard.printDocuments.header.withoutShipment')}
                        </div>
                        <div className="block">
                            <div className="block-row">
                                <div className="block-header">{t('EPCard.printDocuments.downloadHeader')}</div>
                                <Button data-qaid="download_button" variant="secondary" onClick={download}>
                                    {t('EPCard.printDocuments.downloadButton')}
                                </Button>
                            </div>
                        </div>
                        {shipmentOptionsFeatureFlag && (
                            <div className="block">
                                <div className="block-row">
                                    <div className="block-header">{t('EPCard.printDocuments.shipHeader')}</div>
                                    <Button data-qaid="ship_button" variant="secondary" onClick={ship}>
                                        {t('EPCard.printDocuments.shipButton')}
                                    </Button>
                                </div>
                                <div className="block-row">
                                    <div className="block-text">
                                        <HText>{t('EPCard.printDocuments.shipText')}</HText>
                                    </div>
                                    <div className="block-img">
                                        <picture>
                                            <source srcSet={print_docs_webp} type="image/webp" />
                                            <img src={print_docs} alt="Printed documents" />
                                        </picture>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </Frame>
            </CommunityTab>
        </PopUpWrapper>
    );
};

export default ViewDocumentsButton;
